import React from 'react';
import { Link } from 'react-router-dom';
import HomeLeftElement from '../Assets/home-left-elmnts.webp';
import HomeRightElement from '../Assets/home-right-elmnts.webp';
import Monitor from '../Assets/monitor.webp';
import ScreenLine from '../Assets/screen-line.webp';
import Maskot from '../Assets/maskot.webp';
import TabTokenomic from '../Assets/tab-tokenomic.webp';
import TabGrants from '../Assets/tab-grants.webp';
import TabDocs from '../Assets/tab-docs.webp';
import TabAbout from '../Assets/tab-about.webp';
import TabMobileTokenomic from '../Assets/tab-mobile-tokenomic.webp';
import TabMobileGrants from '../Assets/tab-mobile-grants.webp';
import TabMobileDocs from '../Assets/tab-mobile-docs.webp';
import TabMobileAbout from '../Assets/tab-mobile-about.webp';
import { ArrowRightCircleIcon } from '@heroicons/react/24/outline';
import homeButton from '../Assets/home-button.webp';
import homeButtonHover from '../Assets/home-button-hover.webp';
import ConsoleHand from '../Assets/console-hand.webp';

const Home = () => {

  return (
    <main id="home" className="relative pt-5 overflow-x-hidden">
      <img className="absolute top-[35%] left-[0%] w-[35%]" src={HomeLeftElement} alt="Floating Element" />
      <img className="absolute top-[3%] right-[-4%] w-[35%]" src={HomeRightElement} alt="Floating Element" />
      {/* <img className="absolute left-1/2 transform -translate-x-1/2 bottom-0  max-h-[300px] w-auto" src={Planet} alt="ZKcandy Planet" /> */}

      <div className="container mx-auto relative z-10 flex flex-col items-center justify-around lg:justify-between h-full">
        <div className="main-title text-center pt-10">
          <img className="w-full mx-auto max-w-[80%] lg:max-w-[750px] mb-2" src={Maskot} alt="ZKcandy Foundation" />
          <h1 className="text-white text-[6rem] md:text-[7rem] lg:text-[10rem] tracking-[-1.4rem] md:tracking-[-1rem] lg:tracking-[-2rem] leading-[4rem] font-bold font-inversionz text-shadow">ZKcandy</h1>
          <h1 className="text-white text-[2.5rem] md:text-[3rem] lg:text-[4rem] tracking-[-.3rem] md:tracking-[0rem] md:leading-[2rem] leading-[0rem] font-inversionz uppercase mb-10 text-shadow">Foundation</h1>
        </div>

        {/* <div className="flex space-x-4 items-center w-full max-w-[800px] py-10">
          <div className="zk-container text-center text-[1.5rem] font-semibold">
            <div className="left-dot"></div>
            <div className="right-dot"></div>

            <p className="mb-4 leading-[1.3] py-2">We envision a future where Web3 gaming <br /> is accessible to everyone, regardless of <br /> their technical expertise or background.</p>
            <p className="leading-[1.3] py-2 mb-4">The ZKcandy Foundation is committed to <br /> making this vision a reality by supporting developers, educating users, and engaging the community.</p>

            <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[-1.5rem]">
              <Link to="https://zkcandy.io/" target="_blank" className=" text-[1rem] mt-5 btn-purple-shadow flex items-center uppercase">Learn more about ZKcandy <ArrowRightCircleIcon className="size-6 ms-2" /></Link>
            </div>
          </div>
        </div> */}

        <div className="monitor relative md:flex hidden">
          <img src={Monitor} alt="Monitor" />

          <div className="monitor-app flex justify-between w-full absolute left-1/2 transform -translate-x-1/2 top-[13%] left-1/4 grid grid-cols-2 gap-6 max-w-[50%] text-[1.2rem] lg:text-[1.8rem]">
            <Link to="/about" className="w-full monitor-card">
              <div className="inner flex justify-center items-center relative rounded-xl overflow-hidden">
                <div className="absolute font-bold text-white top-1/2 left-1/2 transform -translate-x-1/2 uppercase text-shadow">About</div>
                <img className="h-full w-auto" src={TabAbout} alt="Floating Element" />
              </div>
            </Link>
            <Link to="https://docs.zkcandyapi.com/" target="_blank" className="w-full monitor-card">
              <div className="inner flex justify-center items-center relative rounded-xl overflow-hidden">
                <div className="absolute font-bold text-white right-[4%] top-[13%] uppercase text-shadow">Docs</div>
                <img className="h-full w-auto" src={TabDocs} alt="Floating Element" />
              </div>
            </Link>
            <Link to="/grants-funding" className="w-full monitor-card">
              <div className="inner flex justify-center items-center relative rounded-xl overflow-hidden">
                <div className="absolute font-bold text-white left-[4%] top-[10%] uppercase text-shadow">Grants and Funding</div>
                <img className="h-full w-auto" src={TabGrants} alt="Floating Element" />
              </div>
            </Link>
            <Link to="/tokenomics" className="w-full monitor-card">
              <div className="inner flex justify-center items-center relative  rounded-xl overflow-hidden">
                <div className="absolute font-bold text-white left-[4%] bottom-[10%] uppercase text-shadow">Tokenomics</div>
                <img className="h-full w-auto" src={TabTokenomic} alt="Floating Element" />
              </div>
            </Link>
          </div>

          <a href='https://zkcandy.io/' target='_blank' className='home-button'>
            <img src={homeButton} className='default' alt="Link to ZKcandy" />
            <img src={homeButtonHover} className='hover' alt="Link to ZKcandy" />
          </a>
        </div>

        <div className="mobile-screen relative md:hidden">
            <img className="absolute w-[60%] top-[15%] left-[83%]" src={ConsoleHand} alt="Console Right Hand" />
            <img className="absolute w-[60%] top-[15%] right-[83%] -scale-x-100" src={ConsoleHand} alt="Console Right Hand" />
          <div className="m-4 relative p-4 w-[80%] mx-auto bg-[#4f3878] border-4 border-black rounded-3xl">

            <div className="mobile-app grid grid-cols-2 gap-2 relative overflow-hidden p-4 rounded-2xl border-2 border-white z-10 text-[.8rem]">
              <img className="w-full absolute transform -translate-x-1/2 left-1/2 -translate-y-1/2 top-1/2" src={ScreenLine} alt="Mobile" />
              <Link to="/about" className="w-full monitor-card">
                <div className="inner flex justify-center items-center relative rounded-xl overflow-hidden">
                  <div className="absolute font-bold text-white top-1/2 left-1/2 transform -translate-x-1/2 uppercase text-shadow-mobile">About</div>
                  <img className="h-full w-auto" src={TabMobileAbout} alt="Floating Element" />
                </div>
              </Link>
              <Link to="https://docs.zkcandyapi.com/" target="_blank" className="w-full monitor-card">
                <div className="inner flex justify-center items-center relative rounded-xl overflow-hidden">
                  <div className="absolute font-bold text-white right-[4%] top-[13%] uppercase text-shadow-mobile">Docs</div>
                  <img className="h-full w-auto" src={TabMobileDocs} alt="Floating Element" />
                </div>
              </Link>
              <Link to="/grants-funding" className="w-full monitor-card">
                <div className="inner flex justify-center items-center relative rounded-xl overflow-hidden">
                  <div className="absolute font-bold text-white left-[4%] top-[10%] uppercase text-shadow-mobile leading-none">Grants and Funding</div>
                  <img className="h-full w-auto" src={TabMobileGrants} alt="Floating Element" />
                </div>
              </Link>
              <Link to="/tokenomics" className="w-full monitor-card">
                <div className="inner flex justify-center items-center relative  rounded-xl overflow-hidden">
                  <div className="absolute font-bold text-white left-[4%] top-[10%] uppercase text-shadow-mobile">Tokenomics</div>
                  <img className="h-full w-auto" src={TabMobileTokenomic} alt="Floating Element" />
                </div>
              </Link>
            </div>

            <div className="flex justify-center mt-3">
              <a className="btn-purple-shadow px-4 font-russo uppercase py-1" href='https://zkcandy.io/' target='_blank'>Start Building</a>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;